export const GET_EVENT_LIST_START = 'GET_EVENT_LIST_START';
export const GET_EVENT_LIST_SUCCESS = 'GET_EVENT_LIST_SUCCESS';
export const GET_EVENT_LIST_FAIL = 'GET_EVENT_LIST_FAIL';
